module.exports = __webpack_public_path__ + "static/media/Grouplogos.17cfc528.png";